const actions = {
  draft: ['edit', 'delete', 'confirm'],
  created: ['edit', 'start', 'cancel'],
  running: ['editContacts', 'close'],
  canceled: [],
}

export default (status) => actions[status] || []
